import { render } from "./ChatSidebar.vue?vue&type=template&id=453e5dad"
import script from "./ChatSidebar.vue?vue&type=script&lang=js"
export * from "./ChatSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__